"use client";

import {
  Field,
  Text,
  RichTextField,
  withDatasourceCheck,
  useSitecoreContext,
} from "@sitecore-jss/sitecore-jss-nextjs";
import clsx from "clsx";
import { useEffect, useState } from "react";
import * as AccordionUI from "@repo/ui/accordion";
import { Box } from "@repo/ui/box";
import { TYPOGRAPHY_HEADING1 } from "@/typography-constants";
import { ComponentProps } from "../../types/component-props";
import Placeholder from "../placeholder-component/placeholder";
import { getAccordionSectionUids } from "./utils";
import styles from "./accordion.module.css";

export type AccordionProps = ComponentProps & {
  fields: {
    title: Field<string>;
    paragraph: RichTextField;
  };
  classname?: string;
};

const Accordion = ({
  rendering,
  fields,
  classname,
}: AccordionProps): JSX.Element => {
  const [accordionValue, setAccordionValue] = useState<string[]>([]);

  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing;
  const placeholders = rendering.placeholders;

  useEffect(() => {
    if (isEditing && placeholders) {
      const uidValues = getAccordionSectionUids(rendering);
      setAccordionValue(uidValues as string[]);
    }
  }, [isEditing, rendering]);

  return (
    <Box
      width="100%"
      className={clsx(
        styles.accordionContainer,
        isEditing && styles[classname as string],
        styles.editingContainerSpacing,
      )}
    >
      <Text
        tag={"h2"}
        field={fields.title}
        className={clsx(styles.accordionTitle, TYPOGRAPHY_HEADING1)}
      />
      <AccordionUI.Multiple
        value={accordionValue}
        onValueChange={setAccordionValue}
      >
        {placeholders &&
          Object.entries(placeholders).map(([key]) => (
            <Placeholder key={key} name={key} rendering={rendering} />
          ))}
      </AccordionUI.Multiple>
    </Box>
  );
};

export default withDatasourceCheck()<AccordionProps>(Accordion);
